export default __webpack_public_path__ + "static/media/ic_approved-kyb.1633f4e4.svg";